import React, {useEffect, useRef, useState} from 'react';
import {getXeroCustomer, saveXeroCustomer} from 'api/modules.api';

import {Col, Row,} from "reactstrap";

import InputCustom from '@pages/components/InputCustom';

import Spinner from './../../Spinner';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import notify from "@utils/notify";

export default function XeroPaymentSettings({ deal }) {
    const [customer, setCustomer] = useState({});
    const [isLoading, setIsLoading] = useState(false);



    useEffect(() => {
        if (deal.customer_id) {
            fetchXeroCustomer(deal.customer_id)
        }
    }, [deal.customer_id]);

    const createCustomer = () => {
        saveXeroCustomer(deal.customer_id, customer).then(response => {
            fetchXeroCustomer(deal.customer_id);
            notify.success(response.message);
        })
    }


    const fetchXeroCustomer = (customerId) => {
        setIsLoading(true);
        getXeroCustomer(customerId).then(response => {
            setCustomer(response.data.xeroCustomer)
            setIsLoading(false);
        })
    }

    return (
        <Row className="position-relative">

            {isLoading ? <Spinner animation="border" /> :
              <div className={'p-3'}>
                  <div className='w-100 d-flex flex-wrap align-items-center'>
                      <h2>Customer Settings!</h2>
                      {customer?.contact_id ?
                          <p className='w-100 text-center'><strong>Details below are pulled from XERO customer configuration.</strong></p>
                          : <p className='w-100 text-center text-danger'><strong>This customer does not exist in your XERO list yet!</strong></p>
                      }
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`Contact Name`}
                              value={customer?.name ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      name: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`First Name`}
                              value={customer?.first_name ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      first_name: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`Last name`}
                              value={customer?.last_name ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      last_name: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`email`}
                              label={`Email`}
                              value={customer?.email_address ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      email_address: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      {/* <Col md="12">
                        <p className='w-100 text-center'><strong>Other contact persons</strong></p>
                    </Col>
                    <Col md="6">
                        <InputCustom
                            type={`text`}
                            label={`First Name`}
                            value={customer && customer.contact_persons && customer.contact_persons[0] ? customer.contact_persons[0].first_name : ""}
                            onChange={(e) => {

                                let contactPersons = customer.contact_persons;

                                let contactPerson = {
                                    ...customer.contact_persons[0],
                                    first_name: e.target.value
                                };
                                console.log(contactPerson)
                                contactPersons[0] = contactPerson;

                                setCustomer({
                                    ...customer,
                                    contact_persons: contactPersons,
                                })
                            }
                            }
                        />
                    </Col>
                    <Col md="6">
                        <InputCustom
                            type={`text`}
                            label={`Last Name`}
                            value={customer && customer.contact_persons && customer.contact_persons[0] ? customer.contact_persons[0].last_name : ""}
                            onChange={(e) => {
                                let contactPersons = customer.contact_persons;

                                let contactPerson = {
                                    ...customer.contact_persons[0],
                                    last_name: e.target.value
                                };
                                console.log(contactPerson)
                                contactPersons[0] = contactPerson;

                                setCustomer({
                                    ...customer,
                                    contact_persons: contactPersons,
                                })
                            }}
                        />
                    </Col>
                    <Col md="12">
                        <InputCustom
                            type={`email`}
                            label={`Email`}
                            value={customer && customer.contact_persons && customer.contact_persons[0] ? customer.contact_persons[0].email_address : ""}
                            onChange={(e) => {
                                let contactPersons = customer.contact_persons;

                                let contactPerson = {
                                    ...customer.contact_persons[0],
                                    email_address: e.target.value
                                };
                                console.log(contactPerson)
                                contactPersons[0] = contactPerson;

                                setCustomer({
                                    ...customer,
                                    contact_persons: contactPersons,
                                })
                            }}
                        />
                    </Col>
                    <Col md="12">
                        <InputCustom
                            type={`email`}
                            label={`Phone Number`}
                            value={customer?.contact_name ?? ""}
                            onChange={(e) =>
                                setCustomer({
                                    ...deal,
                                    deal_date: e.target.value,
                                })
                            }
                        />
                    </Col> */}

                      <Col md="12 mt-4">
                          <p className='w-100 text-center'><strong>Address Details</strong></p>
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`Postal Code`}
                              value={customer?.postal_code ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      postal_code: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`Address`}
                              value={customer?.address ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      address: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`City/Town`}
                              value={customer?.city ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      city: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`Region`}
                              value={customer?.county ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      county: e.target.value,
                                  })
                              }
                          />
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                          <InputCustom
                              type={`text`}
                              label={`Country`}
                              value={customer?.country ?? ""}
                              onChange={(e) =>
                                  setCustomer({
                                      ...customer,
                                      country: e.target.value,
                                  })
                              }
                          />
                      </Col>

                  </div>
                  <Col lg={2} md={3} sm={6}>
                      <ButtonContainer
                          className="w-100"
                          reverse
                          onClick={() => createCustomer()}
                      >
                          {(customer?.contact_id ?? null) ? `Update` : `Save`}
                      </ButtonContainer>
                  </Col>
              </div>
            }
        </Row >
    )
}